import { Field } from '@base-ui/react';
import { type FC } from 'react';

import Helper from './index';
import type { HelperProps } from './types';
import { useHelperPresence } from './use-helper-presence';

type HelperDescriptionProps = Pick<HelperProps, 'label' | 'state' | 'iconStart'>;

const HelperDescription: FC<HelperDescriptionProps> = ({ label, state, iconStart }) => {
  const { label: shownLabel, isExiting } = useHelperPresence(label);

  if (!shownLabel) return null;

  return (
    <Field.Description
      render={<Helper state={state} iconStart={iconStart} label={shownLabel} exiting={isExiting} />}
    />
  );
};

HelperDescription.displayName = 'HelperDescription';

export default HelperDescription;
